<div class="multiselect-wrapper relative" [class]="styleClass">
  <div 
    class="multiselect-trigger w-full min-w-[200px] border rounded-lg bg-white cursor-pointer transition-all duration-200"
    [class.opacity-50]="disabled"
    [class.cursor-not-allowed]="disabled"
    (mousedown)="onTriggerMousedownHandler()"
    (click)="toggleDropdown(); $event.stopPropagation()"
  >
    <div class="flex items-center justify-between p-2">
      <div class="flex-1 flex flex-wrap gap-2 min-h-[24px] items-center">
        <!-- Placeholder when no items selected -->
        <span 
          *ngIf="selectedItems.length === 0" 
          class="multiselect-placeholder text-sm"
        >
          {{ placeholder }}
        </span>
        
        <!-- Show individual chips when 1-2 items selected -->
        <ng-container *ngIf="selectedItems.length > 0 && selectedItems.length <= 2 && display === 'chip'">
          <span
            *ngFor="let item of selectedItems"
            class="multiselect-chip"
          >
            <span class="flex-shrink-0">{{ getOptionLabel(item) }}</span>
          </span>
        </ng-container>
        
        <!-- Show count when 3 or more items selected -->
        <span
          *ngIf="selectedItems.length >= 3 && display === 'chip'"
          class="multiselect-chip"
        >
          {{ selectedItems.length }} selected
        </span>
        
        <!-- Comma display mode (fallback) -->
        <span 
          *ngIf="selectedItems.length > 0 && display === 'comma'" 
          class="multiselect-value text-sm"
        >
          {{ getDisplayValue() }}
        </span>
      </div>
      
      <div class="flex items-center gap-2 flex-shrink-0 ml-2">
        <!-- Close icon - show when items are selected -->
        <svg
          *ngIf="selectedItems.length > 0 && showClear && !disabled"
          class="multiselect-clear-icon w-4 h-4 cursor-pointer"
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
          (click)="clearSelection(); $event.stopPropagation()"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
        
        <!-- Caret icon -->
        <svg 
          class="multiselect-icon w-5 h-5 transition-transform duration-200"
          [class.rotate-180]="isOpen"
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
        </svg>
      </div>
    </div>
  </div>

  <!-- Dropdown Panel -->
  <div
    *ngIf="isOpen && options && options.length > 0"
    class="multiselect-panel absolute w-full mt-1 shadow-xl max-h-60 overflow-auto"
    style="top: 100%; left: 0; min-width: 200px; z-index: 10000;"
    (click)="$event.stopPropagation()"
  >
    <!-- Search Filter -->
    <div *ngIf="filter" class="multiselect-search p-2">
      <input
        type="text"
        [(ngModel)]="searchTerm"
        class="multiselect-search-input w-full px-3 py-2 text-sm rounded-md focus:outline-none"
        placeholder="Search..."
        (click)="$event.stopPropagation()"
      />
    </div>

    <!-- Options List -->
    <div class="py-1">
      <div
        *ngFor="let option of filteredOptions; trackBy: trackByOption"
        [class]="getOptionClasses(option)"
        (click)="toggleSelection(option)"
      >
        <!-- Checkbox -->
        <div class="flex items-center mr-3 flex-shrink-0">
          <input
            type="checkbox"
            [checked]="isSelected(option)"
            class="checkbox-custom"
            (click)="$event.stopPropagation(); toggleSelection(option)"
            readonly
          />
        </div>
        
        <!-- Option Label -->
        <span 
          class="multiselect-option-label text-sm flex-1"
          [class.is-selected]="isSelected(option)"
          [class.font-medium]="isSelected(option)"
        >
          {{ getOptionLabel(option) }}
        </span>
      </div>
      
      <div *ngIf="filteredOptions.length === 0" class="multiselect-empty px-3 py-2 text-sm text-center">
        No options found
      </div>
    </div>
  </div>
  
  <!-- Debug: Show if no options -->
  <div *ngIf="isOpen && (!options || options.length === 0)" class="multiselect-panel absolute z-[9999] w-full mt-1 shadow-xl p-3">
    <div class="multiselect-empty text-sm">No options available</div>
  </div>
</div>
